import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentCancel.css';

function PaymentCancel() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRetry = () => {
    navigate('/');
  };

  return (
    <div className="payment-status-container">
      <div className="payment-status-card cancel">
        <div className="status-icon cancel-icon">⚠</div>
        <h2>Payment Cancelled</h2>
        <p className="cancel-message">
          You have cancelled the payment transaction.
        </p>

        <div className="cancel-info">
          <p>
            Your enrollment has not been completed as the payment was cancelled.
            No amount has been deducted from your account.
          </p>
        </div>

        <div className="cancel-suggestions">
          <h3>What would you like to do?</h3>
          <ul>
            <li>Try enrolling again with a different payment method</li>
            <li>Browse other courses that might interest you</li>
            <li>Contact our support team if you need assistance</li>
          </ul>
        </div>

        <div className="cancel-actions">
          <button className="status-button retry-button" onClick={handleRetry}>
            Try Again
          </button>
          <button className="status-button secondary-button" onClick={handleGoHome}>
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
